import { tv } from "tailwind-variants";
import { Button } from "../Button";
import { ApeRushIcon } from "../Icons";

const tabButtonStyles = tv({
	base: "flex items-center justify-center w-1/2 px-6 py-2 rounded-lg transition-all",
	variants: {
		active: {
			true: "bg-black text-white",
			false: "text-neutral-400 hover:text-neutral-200",
		},
		withGap: {
			true: "gap-2",
			false: "",
		},
	},
	defaultVariants: {
		active: false,
		withGap: false,
	},
});

export const PoolTypeTabs = ({
	activeTab,
	onTabChange,
	isApeRushEnabled,
}: {
	activeTab: "all" | "aperush";
	onTabChange: (tab: "all" | "aperush") => void;
	isApeRushEnabled: boolean;
}) => {
	return (
		<div className="flex bg-neutral-700 rounded-lg p-1 w-[400px]">
			<Button
				onClick={() => onTabChange("all")}
				className={tabButtonStyles({
					active: activeTab === "all",
					withGap: false,
				})}
				style={{ width: isApeRushEnabled ? "50%" : "100%" }}
			>
				All
			</Button>
			{isApeRushEnabled && (
				<Button
					onClick={() => onTabChange("aperush")}
					className={tabButtonStyles({
						active: activeTab === "aperush",
						withGap: true,
					})}
				>
					<ApeRushIcon width="20" height="20" />
					<span
						className={`bg-gradient-to-r from-[#1BCCB2] via-[#14D3ED] to-[#1060F0] bg-clip-text text-transparent transition-opacity ${
							activeTab === "aperush"
								? "opacity-100"
								: "opacity-60 hover:opacity-80"
						}`}
					>
						ApeRush
					</span>
				</Button>
			)}
		</div>
	);
};

export default PoolTypeTabs;
